// @flow
import React, { Component } from 'react'
import LineInput from './LineInput'
import styled, { type StyledComponent } from 'styled-components'
import AutoUtmTip from './AutoUtmTip'
import LabeledInput from './LabeledInput'

type Props = {|
  value: string,
  compact?: boolean,
  errors?: Array<string>,
  header: string,
  onChange?: (string) => void,
  disabled?: boolean
|}

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  clear: both;
  white-space: nowrap;
  width: 100%;
`
const Header: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  justify-content: space-between;
`

export default class UrlInput extends Component<Props> {
  render() {
    const { compact, value, onChange, errors, header, disabled } = this.props
    return (
      <Wrapper className="t-UrlInput">
        <LabeledInput
          header={
            <Header>
              {header}
              {!compact && <AutoUtmTip url={value} />}
            </Header>
          }
          input={
            <LineInput
              value={this.props.value}
              onChange={(value) => onChange && onChange(value)}
              disabled={disabled}
            />
          }
          errors={errors}
        />
      </Wrapper>
    )
  }
}
